module.exports = __webpack_public_path__ + "img/icon-share-portfolio.98bf49e4.png";